<template>
    <div v-if="!hash">
        <form-header
            title="Ansuchen"
            subtitle="Strukturförderung (zusätzlicher Unterricht) und Talenteprogramm"
            tag="KAMMERMUSIK / BAND / ENSEMBLE VOLKSMUSIK"
        ></form-header>

        <ValidationObserver ref="form">
            <div>
                <div class="bg-primary">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <transition name="fade">
                            <div
                                class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                                v-show="formbehaviour.alertrequired"
                            >
                                <div class="md:grid md:grid-cols-1 md:gap-3">
                                    <div class="md:col-span-1">
                                        <h3 class="leading-3">
                                            Bitte überprüfen Sie Ihre Eingabe!
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <form-section
                            title="Angaben zum Ensemble"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus."
                        >
                            <text-input
                                v-model="ansuchen.ensemble.name"
                                label="Ensemblename"
                                columns="5"
                                rules="required"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.ensemble.formation"
                                label="Ensembleformation"
                                columns="5"
                                rules="required"
                            ></text-input>
                            <!--<radio-button-list
                                title="Kammermusikformation"
                                v-model="ansuchen.ensemble.kammermusikformation"
                                rules="required"
                                :options="formdata.kammermusikformationen"
                            ></radio-button-list>-->
                        </form-section>

                        <form-section
                            title="Leistungsnachweis Wettbewerbsteilnahme"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus."
                        >
                            <drop-down
                                :values="formdata.wettbewerbe"
                                v-model="ansuchen.wettbewerb.wettbewerbId"
                                label="Wettbewerb"
                                :rules="
                                    ansuchen.wettbewerb.andererwettbewerb
                                        ? ''
                                        : 'required'
                                "
                                columns="3"
                            ></drop-down>
                            <drop-down
                                :values="formdata.altersgruppen"
                                v-model="ansuchen.wettbewerb.altersgruppeId"
                                label="Altersgruppe"
                                :valdisabled="
                                    !formdata.altersgruppen ||
                                        formdata.altersgruppen.length == 0
                                "
                                :rules="
                                    ansuchen.wettbewerb.andererwettbewerb
                                        ? ''
                                        : 'required'
                                "
                                columns="3"
                            ></drop-down>
                            <text-input
                                v-model="ansuchen.wettbewerb.andererwettbewerb"
                                label="oder anderer Wettbewerb und Altersgruppe"
                                columns="4"
                                :rules="
                                    ansuchen.wettbewerb.wettbewerbId
                                        ? ''
                                        : 'required'
                                "
                            ></text-input>
                            <text-input
                                v-model="ansuchen.wettbewerb.ergebnis"
                                label="Wettbewerbsergebnis"
                                columns="4"
                                rules="required"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.wettbewerb.vorspielam"
                                label="Datum des Vorspiels"
                                placeholder="z.B. 21.09.2019"
                                columns="2"
                                rules="required|date"
                            ></text-input>
                        </form-section>

                        <div
                            v-for="(mitglied, index) in ansuchen.ensemble
                                .mitglieder"
                            :key="index"
                            class="mt-2 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                        >
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">
                                    <h3
                                        class="text-lg font-medium leading-6 text-gray-900"
                                    >
                                        {{ index + 1 }}. Ensemblemitglied
                                    </h3>
                                    <p
                                        class="mt-1 text-sm leading-5 text-gray-500"
                                    >
                                        Bitte füllen Sie alle notwendigen Felder
                                        aus.
                                    </p>
                                    <button
                                        v-show="index != 0"
                                        @click="removeEnsembleMitglied(index)"
                                        type="button"
                                        class="mt-4 inline-flex items-center px-48 sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150"
                                    >
                                        Mitglied entfernen
                                    </button>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6">
                                        <drop-down
                                            :values="[
                                                { id: 865250001, name: 'Herr' },
                                                { id: 865250000, name: 'Frau' },
                                            ]"
                                            v-model="mitglied.anrede"
                                            label="Anrede"
                                            rules="required"
                                            columns="2"
                                        ></drop-down>
                                        <div class="col-span-0 sm:col-span-4">
                                            &nbsp;
                                        </div>
                                        <text-input
                                            v-model="mitglied.vorname"
                                            label="Vorname"
                                            columns="3"
                                            rules="required"
                                        ></text-input>
                                        <text-input
                                            v-model="mitglied.nachname"
                                            label="Nachname"
                                            columns="3"
                                            rules="required"
                                        ></text-input>
                                        <drop-down
                                            :values="formdata.faecher"
                                            v-model="mitglied.instrumentId"
                                            label="Instrument"
                                            :valdisabled="
                                                !formdata.faecher ||
                                                    formdata.faecher.length == 0
                                            "
                                            rules="required"
                                            columns="3"
                                        ></drop-down>
                                        <text-input
                                            v-model="mitglied.geburtsdatum"
                                            label="Geburtsdatum"
                                            placeholder="z.B. 14.03.2008"
                                            columns="3"
                                            rules="required|date"
                                        ></text-input>
                                        <text-input
                                            v-model="mitglied.strasse"
                                            label="Straße, Hausnummer"
                                            columns="5"
                                            tooltip="bitte die Meldeadresse angeben"
                                            rules="required"
                                        ></text-input>
                                        <text-input
                                            v-model="mitglied.plz"
                                            label="Postleitzahl"
                                            columns="2"
                                            tooltip="bitte die Meldeadresse angeben"
                                            rules="required|numeric|length:4"
                                        ></text-input>
                                        <text-input
                                            v-model="mitglied.ort"
                                            label="Ort"
                                            columns="4"
                                            tooltip="bitte die Meldeadresse angeben"
                                            rules="required"
                                        ></text-input>
                                        <text-input
                                            v-model="mitglied.email"
                                            label="E-Mail"
                                            columns="3"
                                            rules="required|email"
                                        ></text-input>
                                        <text-input
                                            v-model="mitglied.telefon"
                                            label="Telefon"
                                            columns="3"
                                            rules="required|numeric"
                                        ></text-input>
                                        <div class="col-span-6 sm:col-span-5">
                                            <legend
                                                class="text-base leading-6 font-medium text-gray-900 mt-4 mb-2"
                                            >
                                                Information zum Talenteprogramm
                                            </legend>
                                            <text-block
                                                :content="
                                                    textbausteinfuer(
                                                        'zustimmungen.talenteprogramm'
                                                    ).contentPlain
                                                "
                                            />
                                        </div>

                                        <h3
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            class="mt-4 col-span-6 font-medium"
                                        >
                                            Erziehungsberechtigte/r
                                        </h3>
                                        <drop-down
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            :values="[
                                                { id: 865250001, name: 'Herr' },
                                                { id: 865250000, name: 'Frau' },
                                            ]"
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .anrede
                                            "
                                            label="Anrede"
                                            rules="required"
                                            :valdisabled="
                                                !brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            columns="2"
                                        ></drop-down>
                                        <div class="col-span-0 sm:col-span-4">
                                            &nbsp;
                                        </div>
                                        <text-input
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .prefix
                                            "
                                            label="Titel (vorangestellt)"
                                            columns="2"
                                        ></text-input>
                                        <div class="col-span-0 sm:col-span-4">
                                            &nbsp;
                                        </div>
                                        <text-input
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .vorname
                                            "
                                            label="Vorname"
                                            columns="3"
                                            :valdisabled="
                                                !brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            rules="required"
                                        ></text-input>
                                        <text-input
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .nachname
                                            "
                                            label="Nachname"
                                            :valdisabled="
                                                !brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            rules="required"
                                            columns="3"
                                        ></text-input>
                                        <text-input
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .suffix
                                            "
                                            label="Titel (nachgestellt)"
                                            columns="2"
                                        ></text-input>
                                        <div
                                            class="col-span-0 sm:col-span-4"
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                        >
                                            &nbsp;
                                        </div>
                                        <text-input
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .email
                                            "
                                            label="E-Mail"
                                            columns="3"
                                            :valdisabled="
                                                !brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            rules="required|email"
                                        ></text-input>
                                        <text-input
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .andereemail
                                            "
                                            label="weitere E-Mail"
                                            columns="3"
                                            rules="email"
                                        ></text-input>
                                        <text-input
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .telefon
                                            "
                                            label="Telefonnummer"
                                            columns="3"
                                            :valdisabled="
                                                !brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            rules="required|numeric"
                                        ></text-input>
                                        <text-input
                                            v-show="
                                                brauchterziehungsberechtigten(
                                                    index
                                                )
                                            "
                                            v-model="
                                                mitglied.erziehungsberechtigter
                                                    .anderestelefon
                                            "
                                            label="weitere Telefonnummer"
                                            columns="3"
                                            rules="numeric"
                                        ></text-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="mb-6 mt-2 bg-white shadow px-4 py-4 sm:rounded-lg sm:p-4"
                        >
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span
                                            class="inline-flex rounded-md shadow-sm"
                                        >
                                            <button
                                                @click="addEnsembleMitglied"
                                                type="button"
                                                class="inline-flex items-center px-48 sm:px-4 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                            >
                                                weiteres Mitglied hinzufügen
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <form-section
                            title="Angaben zur Ensembleleitung"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus."
                        >
                            <drop-down
                                :values="[
                                    { id: 865250001, name: 'Herr' },
                                    { id: 865250000, name: 'Frau' },
                                ]"
                                v-model="ansuchen.ensembleleiter.anrede"
                                label="Anrede"
                                rules="required"
                                columns="2"
                            ></drop-down>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.ensembleleiter.prefix"
                                label="Titel (vorangestellt)"
                                columns="2"
                            ></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.ensembleleiter.vorname"
                                label="Vorname"
                                columns="3"
                                rules="required"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.ensembleleiter.nachname"
                                label="Nachname"
                                columns="3"
                                rules="required"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.ensembleleiter.suffix"
                                label="Titel (nachgestellt)"
                                columns="2"
                            ></text-input>
                            <div class="col-span-0 sm:col-span-4">&nbsp;</div>
                            <text-input
                                v-model="ansuchen.ensembleleiter.email"
                                label="E-Mail"
                                columns="3"
                                rules="required|email"
                            ></text-input>
                            <text-input
                                v-model="ansuchen.ensembleleiter.telefon"
                                label="Telefonnummer"
                                columns="3"
                                rules="required|numeric"
                            ></text-input>
                            <drop-down
                                :values="formdata.musikschulen"
                                v-model="ansuchen.musikschuleId"
                                label="Musikschule"
                                rules="required"
                                columns="5"
                            ></drop-down>
                        </form-section>

                        <form-section
                            title="Förderansuchen"
                            subtitle="von der Musikschule auszufüllen"
                        >
                            <div class="col-span-6 sm:col-span-4">
                                <fieldset>
                                    <legend
                                        class="text-base leading-6 font-medium text-gray-900"
                                    >
                                        Zusätzliche Angaben
                                    </legend>
                                    <div class="mt-4">
                                        <check-box
                                            v-model="
                                                ansuchen.ansuchen
                                                    .bereitsgefoerdert
                                            "
                                            label="Die zusätzliche Unterrichtseinheit wurde bereits im aktuellen Schuljahr gefördert."
                                        ></check-box>
                                        <check-box
                                            v-model="
                                                ansuchen.ansuchen
                                                    .bestaetigungzusaetzlicherunterricht
                                            "
                                            label="Ich bestätige, dass das Ensemble in dem Schuljahr, für das die Talenteförderung beantragt wird, mindestens 50 Minuten Ensembleunterricht (Ergänzungsfach) erhalten wird."
                                        ></check-box>
                                    </div>
                                </fieldset>
                            </div>
                        </form-section>

                        <form-section
                            title="Beilagen"
                            subtitle="Bitte laden Sie die erforderlichen Dokumente hoch."
                        >
                            <file-upload
                                label="Meldebestätigungen (Meldezettel) aller Ensemblemitglieder (nur bei erstmaligem Ansuchen, oder bei Veränderung des Hauptwohnsitzes)"
                                columns="4"
                                :maxSize="5"
                                @size-exceeded="onSizeExceeded"
                                @metadata="onMeldezettel"
                                @fileloaded="onMeldezettelLoad"
                            ></file-upload>

                            <file-upload
                                label="Urkunde Wettbewerb (nur bei einem Antritt in einem anderen Bundesland als NÖ oder anderer Wettbewerb)"
                                columns="4"
                                :maxSize="5"
                                @size-exceeded="onSizeExceeded"
                                @metadata="onWettbewerbErgebnis"
                                @fileloaded="onWettbewerbErgebnisLoad"
                            ></file-upload>
                        </form-section>

                        <form-section
                            title="Einverständniserklärung"
                            subtitle="Bitte lesen Sie aufmerksam die Bestimmungen"
                        >
                            <div class="col-span-6 sm:col-span-5">
                                <legend
                                    class="text-base leading-6 font-medium text-gray-900 mb-2"
                                >
                                    Information Schulerhalter
                                </legend>
                                <text-block
                                    :content="
                                        textbausteinfuer(
                                            'zustimmungen.schulhalter'
                                        ).contentPlain
                                    "
                                />
                            </div>
                        </form-section>

                        <form-section
                            title="Informationspflicht"
                            subtitle="gem. Art. 13 DSGVO"
                        >
                            <div class="col-span-6 sm:col-span-5">
                                <text-block
                                    :content="
                                        textbausteinfuer(
                                            'allgemein.informationspflicht'
                                        ).contentPlain
                                    "
                                />
                            </div>
                        </form-section>

                        <form-section
                            title="Bestätigung"
                            subtitle="Bitte geben Sie die E-Mailadresse an, an welche eine Eingangsbestätigung gesendet werden soll."
                        >
                            <text-input
                                v-model="ansuchen.bestaetigungsemail"
                                label="E-Mail"
                                rules="required|email"
                                columns="4"
                            ></text-input>
                            <div class="col-span-6">
                                <fieldset>
                                    <div class="mt-4">
                                        <check-box
                                            v-model="
                                                ansuchen.zustimmungen.hinweis
                                            "
                                            label="Hinweis"
                                            rules="required"
                                            :description="
                                                textbausteinfuer(
                                                    'zustimmungen.hinweis'
                                                ).contentPlain
                                            "
                                        ></check-box>
                                    </div>
                                </fieldset>
                            </div>
                        </form-section>

                        <div
                            class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                        >
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span
                                            class="inline-flex rounded-md shadow-sm"
                                        >
                                            <button
                                                @click="openSubmitModal()"
                                                type="button"
                                                class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                            >
                                                Ansuchen absenden
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>

        <transition name="fade">
            <div
                v-show="formbehaviour.showSendModal"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.showSendModal"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.showSendModal"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
                >
                    <div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Ansuchen absenden
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Nach dem Absenden können Sie den Antrag als
                                    PDF herunterladen. Bitte drucken Sie ihn aus
                                    und übermitteln ihn unterfertigt per Post an
                                    uns.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                    >
                        <span
                            class="flex w-full rounded-md shadow-sm sm:col-start-2"
                        >
                            <button
                                @click="sendAnsuchen()"
                                type="button"
                                :disabled="formbehaviour.sending"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 text-base leading-6 font-medium text-white shadow-sm focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                :class="[
                                    formbehaviour.sending
                                        ? ' bg-gray-300'
                                        : 'bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green',
                                ]"
                            >
                                Absenden
                            </button>
                        </span>
                        <span
                            class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:col-start-1"
                        >
                            <button
                                @click="formbehaviour.showSendModal = false"
                                type="button"
                                :disabled="formbehaviour.sending"
                                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 text-base leading-6 font-medium shadow-sm transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                                :class="[
                                    formbehaviour.sending
                                        ? ' bg-gray-300 text-white'
                                        : 'bg-white text-gray-700 focus:outline-none focus:border-blue-300 focus:shadow-outline hover:text-gray-500',
                                ]"
                            >
                                Zurück
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end"
            >
                <div
                    v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto"
                >
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg
                                        class="h-6 w-6 text-green-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p
                                        class="text-sm leading-5 font-medium text-gray-900"
                                    >
                                        Validierung erfolgreich.
                                    </p>
                                    <p
                                        class="mt-1 text-sm leading-5 text-gray-500"
                                    >
                                        Übermittle das Ansuchen.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div
                v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
            >
                <div
                    v-show="formbehaviour.successful"
                    class="fixed inset-0 transition-opacity"
                >
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div
                    v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6"
                >
                    <div>
                        <div
                            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
                        >
                            <svg
                                class="h-6 w-6 text-green-600"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3
                                class="text-lg leading-6 font-medium text-gray-900"
                            >
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Bitte drucken Sie den Antrag aus und
                                    übermitteln ihn unterschrieben per E-Mail an
                                    das Musik &amp; Kunst Schulen Management
                                    Niederösterreich.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5 sm:mt-6">
                        <span class="flex w-full rounded-md shadow-sm">
                            <button
                                @click="generatePdf()"
                                type="button"
                                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-indigo-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                            >
                                Dokument herunterladen
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import FormSection from '@/components/forms/FormSection.vue'
import FormHeader from '@/components/forms/FormHeader.vue'

import TextInput from '@/components/inputs/TextInput.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import RadioButtonList from '@/components/inputs/RadioButtonList.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'

import FileUpload from '@/components/inputs/FileUpload.vue'

import * as JsPDF from 'jspdf'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        hash: {
            type: String,
            required: false,
        },
    },
    components: {
        TextInput,
        CheckBox,
        DropDown,
        FormSection,
        FormHeader,
        RadioButtonList,
        TextBlock,
        FileUpload,
    },
    data: function() {
        return {
            formbehaviour: {
                showSendModal: false,
                instrument: [],
                musikschulen: [],
                altersstufen: [],
                alertrequired: false,
                sending: false,
                successful: false,
            },
            formdata: {
                musikschulen: [],
                wettbewerbe: [],
                faecher: [],
                altersgruppen: [],
                textbausteine: [],
                kammermusikformationen: {
                    'Streichquartett (Violine I und II, Viola, Violoncello)': 180620000,
                    'Klaviertrio (Klavier, Violine, Violoncello)': 180620001,
                    'Holzbläserquintett (Flöte, Oboe, Klarinette, Horn, Fagott)': 180620002,
                    'Blechbläserquintett (Trompete I und II, Horn, Posaune, Tuba)': 180620003,
                    Hornquartett: 180730001,
                    'Blockflötenquartett (mindestens drei verschiedene Stimmlagen)': 180730002,
                    'Saxophonquartett (mindestens drei verschiedene Stimmlagen)': 180730003,
                    'Schlagwerkensemble (verpflichtendes Stabspiel)': 180730004,
                    'Vokalensemble (mindestens drei Stimmlagen)': 180730005,
                    'Ensembles, die aus mindestens zwei Instrumentengattungen bestehen': 180730006,
                    'Ensemble Kreativ': 180730007,
                    'Volksmusik Ensemble': 180730000,
                    'Band Jazz/Pop/Rock': 180730008,
                },
            },
            ansuchen: {
                bestaetigungsemail: null,
                ensemble: {
                    name: null,
                    formation: null,
                    kammermusikformation: null,
                    mitglieder: [
                        {
                            anrede: null,
                            vorname: null,
                            nachname: null,
                            geburtsdatum: null,
                            email: null,
                            instrumentId: null,
                            zustimmungtalenteprogramm: false,
                            zustimmungBildUndTon: false,
                            zustimmungtalenteprogrammeinblenden: false,
                            zustimmungbildundtoneinblenden: false,
                            erziehungsberechtigter: {
                                anrede: null,
                                vorname: null,
                                nachname: null,
                                prefix: null,
                                suffix: null,
                                email: null,
                                andereemail: null,
                                telefon: null,
                                anderestelefon: null,
                            },
                        },
                    ],
                },
                musikschuleId: null,
                wettbewerb: {
                    wettbewerbId: null,
                    altersgruppeId: null,
                    ergebnis: null,
                    vorspielam: null,
                    andererwettbewerb: null,
                },
                ensembleleiter: {
                    anrede: null,
                    vorname: null,
                    nachname: null,
                    prefix: null,
                    suffix: null,
                    email: null,
                    telefon: null,
                },
                ansuchen: {
                    bereitsgefoerdert: false,
                    bestaetigungzusaetzlicherunterricht: false,
                },
                meldezettel: {
                    subject: 'Upload - Meldezettel',
                    filename: null,
                    mimeType: null,
                    body: null,
                },
                wettbewerbErgebnis: {
                    subject: 'Upload - Wettbewerb',
                    filename: null,
                    mimeType: null,
                    body: null,
                },
                zustimmungen: {
                    schulhalter: false,
                    talenteprogramm: false,
                    bildundton: false,
                    datenschutz: false,
                    hinweis: false,
                },
            },
        }
    },
    watch: {
        wettbewerbId() {
            if (this.ansuchen.wettbewerb.wettbewerbId) {
                this.fetchFaecher(this.ansuchen.wettbewerb.wettbewerbId)
                this.fetchAltersgruppen(this.ansuchen.wettbewerb.wettbewerbId)
            }
        },
        andererwettbewerb() {
            if (this.ansuchen.wettbewerb.andererwettbewerb) {
                this.fetchFaecher('eb3b2dde-d9e5-ee11-904c-002248807e04')
            }
        },
    },
    computed: {
        wettbewerbId() {
            return this.ansuchen.wettbewerb.wettbewerbId
        },
        andererwettbewerb() {
            return this.ansuchen.wettbewerb.andererwettbewerb
        },
    },
    methods: {
        addEnsembleMitglied: function() {
            this.ansuchen.ensemble.mitglieder.push({
                anrede: null,
                vorname: null,
                nachname: null,
                geburtsdatum: null,
                email: null,
                zustimmungtalenteprogramm: false,
                zustimmungBildUndTon: false,
                zustimmungtalenteprogrammeinblenden: false,
                zustimmungbildundtoneinblenden: false,
                erziehungsberechtigter: {
                    anrede: null,
                    vorname: null,
                    nachname: null,
                    prefix: null,
                    suffix: null,
                    email: null,
                    andereemail: null,
                    telefon: null,
                    anderestelefon: null,
                },
            })
        },

        removeEnsembleMitglied: function(index) {
            this.ansuchen.ensemble.mitglieder.splice(index, 1)
        },

        brauchterziehungsberechtigten: function(index) {
            if (!this.ansuchen.ensemble.mitglieder[index].geburtsdatum)
                return false

            var parts = this.ansuchen.ensemble.mitglieder[
                index
            ].geburtsdatum.split('.')

            if (parts.length < 3) return false

            var parsed = new Date(
                parseInt(parts[2], 10),
                parseInt(parts[1], 10) - 1,
                parseInt(parts[0], 10)
            )

            if (!parsed) return false

            var ageDifMs = Date.now() - parsed
            var ageDate = new Date(ageDifMs) // miliseconds from epoch

            return Math.abs(ageDate.getUTCFullYear() - 1970) < 18
        },

        async fetchTextBausteine() {
            const { data } = await this.service.formular
                .get('strukturfoerderung')
                .textbloeckePowerApps()
            this.formdata.textbausteine = data
        },

        async fetchMusikschulen() {
            const { data } = await this.service.musikschule.powerAppsAlle()
            this.formdata.musikschulen = data
        },

        async fetchWettbewerbe() {
            const { data } = await this.service.wettbewerb.alle()

            if (data.find(e => e.id == '00000000-0000-0000-0000-000000000000'))
                data.push({
                    id: '00000000-0000-0000-0000-000000000000',
                    name: 'anderer Wettbewerb',
                })

            this.formdata.wettbewerbe = data
        },

        async fetchFaecher(wettbewerbId) {
            const { data } = await this.service.wettbewerb
                .get(wettbewerbId)
                .faecher()
            this.formdata.faecher = data
        },

        async fetchAltersgruppen(wettbewerbId) {
            const { data } = await this.service.wettbewerb
                .get(wettbewerbId)
                .altersgruppen('2')
            this.formdata.altersgruppen = data
        },

        openSubmitModal() {
            this.$refs.form.validate().then(success => {
                if (!success) {
                    window.scrollTo(0, 0)
                    this.formbehaviour.alertrequired = true
                    return
                }

                this.formbehaviour.showSendModal = true
            })
        },

        async sendAnsuchen() {
            if (this.formbehaviour.sending) {
                return
            }

            try {
                this.formbehaviour.sending = true
                await this.service.formular.senden(
                    'talentensemble',
                    this.ansuchen
                )
                this.formbehaviour.showSendModal = false
                this.formbehaviour.successful = true
            } catch (error) {
                console.log(Object.keys(error), error.message)
            } finally {
                this.formbehaviour.sending = false
            }
        },

        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found
        },

        onMeldezettel(file) {
            this.ansuchen.meldezettel.mimeType = file.type
            this.ansuchen.meldezettel.filename = file.name
        },

        onMeldezettelLoad(dataUri) {
            this.ansuchen.meldezettel.body = dataUri
        },

        onWettbewerbErgebnis(file) {
            this.ansuchen.wettbewerbErgebnis.mimeType = file.type
            this.ansuchen.wettbewerbErgebnis.filename = file.name
        },

        onWettbewerbErgebnisLoad(dataUri) {
            this.ansuchen.wettbewerbErgebnis.body = dataUri
        },

        onSizeExceeded(size) {
            alert(`Datei mit ${size}MB zu groß. (Maximal 5 MB)`)
        },

        getKammerMusikFormationLabel(value) {
            switch (value) {
                case 180620000:
                    return 'Streichquartett'
                case 180620001:
                    return 'Klaviertrio'
                case 180620002:
                    return 'Holzbläserquintett'
                case 180620003:
                    return 'Blechbläserquintett'
                case 180730001:
                    return 'Hornquartett'
                case 180730002:
                    return 'Blockflötenquartett'
                case 180730003:
                    return 'Saxophonquartett'
                case 180730004:
                    return 'Schlagwerkensemble'
                case 180730005:
                    return 'Vokalensemble'
                case 180730006:
                    return 'Ensembles (mind. 2 Instrumentengattungen)'
                case 180730007:
                    return 'Ensemble Kreativ'
                case 180730000:
                    return 'Volksmusik Ensemble'
                case 180730008:
                    return 'Band Jazz/Pop/Rock'
                default:
                    return ''
            }
        },

        generatePdf() {
            var doc = new JsPDF()

            let x = 20
            let y = 40

            var page = 1
            var pages =
                2 +
                (Math.floor(this.ansuchen.ensemble.mitglieder.length / 3) +
                    (this.ansuchen.ensemble.mitglieder.length % 3 != 0 ? 1 : 0))

            doc.setFontType('normal')
            doc.setFontSize(11)

            const logo = require('@/assets/img/logo.jpg')
            var imgLogo = new Image()
            imgLogo.src = logo
            const footerlogo = require('@/assets/img/footerlogo.png')
            var imgFooter = new Image()
            imgFooter.src = footerlogo
            doc.addImage(imgLogo, 'PNG', 140, 5)
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
            doc.text(`Seite ${page++} von ${pages}`, 17, 285, 'left')

            doc.text(x, y, 'An die: ')
            doc.text(
                x,
                y + 5,
                'MKM Musik & Kunst Schulen Management Niederösterreich GmbH'
            )
            doc.text(x, y + 10, 'Neue Herrengasse 10')
            doc.text(x, y + 15, '3100 St. Pölten')

            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(
                x,
                y + 40,
                'ANSUCHEN: Strukturförderung (zusätzlicher Unterricht) und Talenteprogramm'
            )
            doc.text(x, y + 45, 'KAMMERMUSIK / BAND / ENSEMBLE VOLKSMUSIK')

            y = 100
            doc.setFontType('bold')
            doc.text(x, y, 'Angaben zum Ensemble')
            doc.setFontSize(11)
            doc.setFontType('normal')
            doc.text(x, y + 6, 'Name:')
            //doc.text(x, y + 12, 'Kammermusikformation:')
            doc.text(x, y + 12, 'Ensembleformation:')

            doc.text(x + 45, y + 6, this.ansuchen.ensemble.name || '')
            /*doc.text(
                x + 45,
                y + 12,
                this.getKammerMusikFormationLabel(
                    this.ansuchen.ensemble.kammermusikformation
                )
            )*/

            doc.text(x + 45, y + 12, this.ansuchen.ensemble.formation || '')

            y = 130
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Leistungsnachweis Wettbewerbsteilnahme')
            doc.setFontType('normal')
            doc.setFontSize(11)
            doc.text(x, y + 6, 'Wettbewerb:')
            doc.text(x, y + 12, 'Altersgruppe:')
            doc.text(x, y + 18, 'Wettbewerbsergebnis:')
            doc.text(x, y + 24, 'Datum des Vorspiels:')

            doc.text(
                x + 40,
                y + 6,
                this.ansuchen.wettbewerb.wettbewerbId != null &&
                    this.formdata.wettbewerbe.find(
                        wb => wb.id == this.ansuchen.wettbewerb.wettbewerbId
                    ) != null
                    ? this.formdata.wettbewerbe.find(
                          wb => wb.id == this.ansuchen.wettbewerb.wettbewerbId
                      ).name
                    : this.ansuchen.wettbewerb.andererwettbewerb || ''
            )
            doc.text(
                x + 40,
                y + 12,
                this.ansuchen.wettbewerb.altersgruppeId != null &&
                    this.formdata.altersgruppen.find(
                        ag => ag.id == this.ansuchen.wettbewerb.altersgruppeId
                    ) != null
                    ? this.formdata.altersgruppen.find(
                          ag => ag.id == this.ansuchen.wettbewerb.altersgruppeId
                      ).name
                    : '---'
            )
            doc.text(x + 40, y + 18, this.ansuchen.wettbewerb.ergebnis || '')
            doc.text(x + 40, y + 24, this.ansuchen.wettbewerb.vorspielam || '')

            y = 165
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Angaben zur Ensembleleitung')
            doc.setFontSize(11)
            doc.setFontType('normal')
            doc.text(x, y + 6, 'Anrede:')
            doc.text(x, y + 12, 'Titel:')
            doc.text(x, y + 18, 'Vorname:')
            doc.text(x, y + 24, 'Name:')
            doc.text(x, y + 30, 'Suffix:')
            doc.text(x, y + 36, 'E-Mail:')
            doc.text(x, y + 42, 'Telefon:')
            doc.text(x, y + 48, 'Musikschule:')

            doc.text(
                x + 30,
                y + 6,
                this.ansuchen.ensembleleiter.anrede == 865250001
                    ? 'Herr'
                    : 'Frau'
            )
            doc.text(x + 30, y + 12, this.ansuchen.ensembleleiter.prefix || '')
            doc.text(x + 30, y + 18, this.ansuchen.ensembleleiter.vorname || '')
            doc.text(
                x + 30,
                y + 24,
                this.ansuchen.ensembleleiter.nachname || ''
            )
            doc.text(x + 30, y + 30, this.ansuchen.ensembleleiter.suffix || '')
            doc.text(x + 30, y + 36, this.ansuchen.ensembleleiter.email || '')
            doc.text(x + 30, y + 42, this.ansuchen.ensembleleiter.telefon || '')
            doc.text(
                x + 30,
                y + 48,
                this.formdata.musikschulen.find(
                    ms => ms.id == this.ansuchen.musikschuleId
                ).name
            )

            y = 226
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Förderansuchen')
            doc.setFontType('normal')
            doc.setFontSize(11)
            doc.setFontType('bold')
            doc.text(
                x,
                y + 8,
                this.ansuchen.ansuchen.bereitsgefoerdert ? 'JA' : 'NEIN'
            )
            doc.setFontType('normal')
            doc.text(
                x + 20,
                y + 8,
                'Die zusätzliche Unterrichtseinheit wurde bereits im aktuellen Schuljahr gefördert.'
            )

            var paragraph =
                'Hiermit wird vom Schulerhalter bestätigt, dass das Schulgeld für die zusätzliche Unterrichtseinheit bei positivem Ansuchen den Eltern NICHT verrechnet wird, sowie Änderungen des Wohnsitzes oder eine Abmeldung des/der SchülerIn von der Musikschule, der MKM Musik & Kunst Schulen Management Niederösterreich GmbH unverzüglich zur Kenntnis gebracht werden.'

            var lines = doc.splitTextToSize(paragraph, 155)
            doc.setFontType('bold')
            doc.text(
                x,
                y + 16,
                this.ansuchen.ansuchen.bestaetigungzusaetzlicherunterricht
                    ? 'JA'
                    : 'NEIN'
            )
            doc.setFontType('normal')
            doc.text(x + 20, y + 16, lines)

            doc.addPage()
            doc.addImage(imgLogo, 'PNG', 140, 5)
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
            doc.text(`Seite ${page++} von ${pages}`, 17, 285, 'left')

            y = 35
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Angaben zu den Ensemblemitgliedern')
            doc.setFontSize(11)
            doc.setFontType('normal')

            y = 45

            this.ansuchen.ensemble.mitglieder.forEach(mitglied => {
                x = 20
                if (y > 200) {
                    doc.addPage()
                    doc.addImage(imgLogo, 'PNG', 140, 5)
                    doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
                    doc.text(`Seite ${page++} von ${pages}`, 17, 285, 'left')

                    y = 45
                }

                doc.setFontSize(11)
                doc.setFontType('bold')
                doc.text(x, y, 'Schüler/in')
                doc.setFontType('normal')
                doc.text(x, y + 6, 'Anrede:')
                doc.text(x, y + 12, 'Vorname:')
                doc.text(x, y + 18, 'Name:')
                doc.text(x, y + 24, 'Geb. am:')
                doc.text(x, y + 30, 'Straße, Nr.:')
                doc.text(x, y + 36, 'PLZ / Ort:')
                doc.text(x, y + 42, 'E-Mail:')
                doc.text(x, y + 48, 'Telefon:')
                doc.text(x, y + 54, 'Instrument:')

                doc.setFontType('normal')
                doc.setFontSize(11)

                doc.text(
                    x + 22,
                    y + 6,
                    mitglied.anrede == 865250001 ? 'Herr' : 'Frau'
                )
                doc.text(x + 22, y + 12, mitglied.vorname || '')
                doc.text(x + 22, y + 18, mitglied.nachname || '')
                doc.text(x + 22, y + 24, mitglied.geburtsdatum || '')
                doc.text(x + 22, y + 30, mitglied.strasse || '')
                doc.text(
                    x + 22,
                    y + 36,
                    (mitglied.plz || '') + ' ' + (mitglied.ort || '')
                )
                doc.text(x + 22, y + 42, mitglied.email || '')
                doc.text(x + 22, y + 48, mitglied.telefon || '')

                var fach = this.formdata.faecher.find(
                    fa => fa.id == mitglied.instrumentId
                )

                if (fach) {
                    doc.text(x + 20, y + 54, fach.name)
                }

                if (
                    mitglied.erziehungsberechtigter.nachname &&
                    mitglied.erziehungsberechtigter.nachname != ''
                ) {
                    x = 110
                    doc.setFontType('bold')
                    doc.text(x, y, 'Erziehungberechtigte/r')
                    doc.setFontType('normal')
                    doc.text(x, y + 6, 'Anrede:')
                    doc.text(x, y + 12, 'Titel:')
                    doc.text(x, y + 18, 'Vorname:')
                    doc.text(x, y + 24, 'Name:')
                    doc.text(x, y + 30, 'Suffix:')
                    doc.text(x, y + 36, 'E-Mail 1:')
                    doc.text(x, y + 42, 'E-Mail 2:')
                    doc.text(x, y + 48, 'Telefon 1:')
                    doc.text(x, y + 54, 'Telefon 2:')

                    doc.text(
                        x + 20,
                        y + 6,
                        mitglied.erziehungsberechtigter.anrede == 865250001
                            ? 'Herr'
                            : ''
                    )
                    doc.text(
                        x + 20,
                        y + 12,
                        mitglied.erziehungsberechtigter.prefix || ''
                    )
                    doc.text(
                        x + 20,
                        y + 18,
                        mitglied.erziehungsberechtigter.vorname || ''
                    )
                    doc.text(
                        x + 20,
                        y + 24,
                        mitglied.erziehungsberechtigter.nachname || ''
                    )
                    doc.text(
                        x + 20,
                        y + 30,
                        mitglied.erziehungsberechtigter.suffix || ''
                    )
                    doc.text(
                        x + 20,
                        y + 36,
                        mitglied.erziehungsberechtigter.email || ''
                    )
                    doc.text(
                        x + 20,
                        y + 42,
                        mitglied.erziehungsberechtigter.andereEmail || ''
                    )
                    doc.text(
                        x + 20,
                        y + 48,
                        mitglied.erziehungsberechtigter.telefon || ''
                    )
                    doc.text(
                        x + 20,
                        y + 54,
                        mitglied.erziehungsberechtigter.anderesTelefon || ''
                    )
                }
                y = y + 63
            })

            x = 20
            y = 245
            doc.text(x, y, '_________________________________')
            doc.text(x, y + 5, 'Unterschrift Ensembleleitung')

            doc.text(x, y + 20, '_________________________________')
            doc.text(x, y + 25, 'Unterschrift MusikschulleiterIn')

            doc.text(x + 95, y + 20, '_________________________________')
            doc.text(x + 95, y + 25, 'Unterschrift Schulerhalter')

            doc.addPage()
            doc.addImage(imgLogo, 'PNG', 140, 5)
            doc.addImage(imgFooter, 'PNG', 145, 275, 50, 10)
            doc.text(`Seite ${page++} von ${pages}`, 17, 285, 'left')

            x = 20
            y = 45
            doc.setFontType('bold')
            doc.setFontSize(12)
            doc.text(x, y, 'Informationspflicht gem. Art. 13 DSGVO')
            doc.setFontType('normal')
            doc.setFontSize(10)
            paragraph =
                'Verantwortlicher: MKM Musik & Kunst Schulen Management Niederösterreich GmbH, 3100 St. Pölten, Neue Herrengasse 10, Telefon: +43 2742 9005 16880, Telefax: +43 2742 9005 16820, Webseite: www.mkmnoe.at, E-Mail: office@mkmnoe.at\r\n\r\nDatenschutzbeauftragter: Fabian Röper, MA MA, 3100 St. Pölten, Hypogasse 1/2.Stock, Telefon: +43 2742 9005 16895, E-Mail: datenschutz@mkmnoe.at\r\n\r\nZweck der Verarbeitung und Rechtsgrundlage: Ihre personenbezogenen Daten (Schüler: Vorname, Nachname, Instrument, Geburtsdatum, PLZ, Ort, Telefonnummer, E-Mail Adresse, Wettbewerbsergebnis, Altersgruppe, Meldebestätigung; Lehrende/Ensembleleitung: Titel, Vorname, Nachname, E-Mail, Telefonnummer und ggfs. Erziehungsberechtigte: Titel, Vorname, Nachname, Telefonnummer, E-Mail Adresse) werden zum Zweck der Prüfung des Anspruchs auf Aufnahme in das Talenteförderprogramm (Strukturförderung zusätzlicher Unterricht) und der damit verbundenen Teilnahme am Talenteprogramm (zB Meisterkurse, Workshops, etc.) verarbeitet.\r\n\r\nDie Daten werden intern von den zuständigen Mitarbeiterinnen und Mitarbeitern, welche mit der Abwicklung der Talenteförderung betraut sind, verarbeitet und nur dann intern oder an Dritte weitergegeben, wenn dies zum Zweck der Vertragsabwicklung erforderlich ist, oder, im berechtigten Interesse der Verantwortlichen gem. Art 6 Abs 1 lit f DSGVO liegt, oder Sie der Verarbeitung der Daten davor zugestimmt haben.\r\n\r\nDie Verarbeitung erfolgt aufgrund der vertraglichen Verpflichtungen und Notwendigkeiten, welche sich aus der Aufnahme in das Talenteförderprogramm ergeben, bzw. aufgrund einer Vertragsanbahnung bzw. zur Vertragserfüllung gem. Art 6 Abs 1 lit b DSGVO, aufgrund rechtlicher Verpflichtungen des Verantwortlichen gem. Art 6 Abs 1 lit c DSGVO oder aufgrund des berechtigten Interesses der Verantwortlichen gem. Art 6 Abs 1 lit f DSGVO.\r\n\r\nSpeicherdauer: Die Speicherung der Daten erfolgt für die Dauer der Teilnahme am Talenteförderprogramm/Talenteprogramm bzw. aufgrund gesetzlicher Pflichten im Ausmaß von jedenfalls 10 Jahren.\r\n\r\nRechte der betroffenen Personen: Auskunft und Berichtigung und Einschränkung der Verarbeitung der personenbezogenen Daten. Weiters haben Sie das Recht auf Beschwerde bei der Aufsichtsbehörde (Österreichische Datenschutzbehörde, Wickenburggasse 8, 1080 Wien, dsb @dsb.gv.at). Nähere Informationen finden Sie in unserer Datenschutzerklärung unter https://www.mkmnoe.at/datenschutz.'
            lines = doc.splitTextToSize(paragraph, 175)
            doc.text(x, y + 7, lines)

            y = 200
            doc.line(x, 200, 190, 200, null)

            doc.save('ansuchen.pdf')
        },
        async fetchHashAndGeneratePdf(hash) {
            const { data } = await this.service.formular.byhash(hash)
            this.ansuchen = data
            await this.fetchFaecher(
                this.ansuchen.wettbewerb.andererwettbewerb
                    ? 'e5e79512-6f79-ea11-bb90-000c29cb3d8b'
                    : this.ansuchen.wettbewerb.wettbewerbId
            )
            await this.fetchAltersgruppen(
                this.ansuchen.wettbewerb.andererwettbewerb
                    ? 'e5e79512-6f79-ea11-bb90-000c29cb3d8b'
                    : this.ansuchen.wettbewerb.wettbewerbId
            )
            this.generatePdf()
        },
        async initData() {
            await this.fetchMusikschulen()
            await this.fetchTextBausteine()
            await this.fetchWettbewerbe()
        },
    },
    created() {
        this.initData().then(() => {
            if (this.hash) {
                this.fetchHashAndGeneratePdf(this.hash)
            }
        })
    },

    beforeDestroy() {},
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
